// import GET_ARTICLES from '../plugins/getArticles';
import 'slick-carousel';

const [ w, d, mq ] = [ window, document, window.matchMedia( "(max-width: 900px)" ) ]

const init = () => {
  const content = { module:'content4',content:'member'}
  $(()=>{
    resolve()
  })
  $.when(
    $.getArticle(content),
  ).done(items => {
    member_list(items)
  }).done(items => {
    member_list(items)
  }).done(()=>{
    slickCarousel()
  })
}

const member_list = items => {
  const $container = $('.greeting__member-list')
  items.forEach(item => {
    $(`<a href="${item.href}" class="greeting__member-link is-${window.siteinfo.sextable[item.id]||'male'}">
        <img src="${item.thumb.replace(/\/content1\/up_img\/(staff_[^_]+)_l\.(jpg|jpeg)/i,'/Image/staff/$1_s.jpg')}" alt="${item.title} ${item.desc}" width="350" class="greeting__member-img">
        <p class="greeting__member-name"><span>${item.desc.split('|')[0].replace(/^\s|\s$/m,'').replace(/\s+?/,'<br>')}</span></p>
      </a>`).appendTo( $container )
  })
}

const slickCarousel = () =>
  {$('.greeting__member-list').slick({
    autoplay: true,
    fade: false,
    speed: 1500,
    centerMode: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    arrows: false,
    infinite: true,
    variableWidth: true,
    swipeToSlide:true,
    slidesToShow: 4,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        centerMode: true
      }
    }]
  })
}


export default function CORPORATO() {
  $( init )
}